export default class ActiveDirectoryService {
  /** Retrieve a user's avatar from the active directory 
   * @param {String} user user search string
   * @param {Boolean} isLoggedUser boolean to indicate if it's logged user
  */
  async getUserAvatar(user = null, isLoggedUser = true) {}

  /**
   * Get a list of users with a name or mail that starts with the search string
   * @param {String} searchTerm search string
   */
  async searchUsers(searchTerm) {}
}
